// Comportamento comum das abas editáveis do editor de campanha v2:
// carga sob demanda (só quando a aba é aberta pela 1ª vez), detecção de alterações
// não salvas, gravação com token de versão e tratamento do conflito (409).
//
// Cada aba implementa:
//   fetchSection()      -> Promise com o DTO da aba (GET)
//   toForm(dto)         -> objeto do formulário (dados editáveis)
//   buildPayload()      -> corpo do PUT (sem campaignId/version, que o mixin adiciona)
//   saveSection(body)   -> Promise com { version, updatedAt } (PUT)
//   hasPendingFiles()   -> (opcional) true se há imagem nova escolhida
//   afterLoad(dto)      -> (opcional) hook após carregar
export default {
	props: {
		campaignId: { type: [Number, String], required: true },
		// { from, to, seq }: outra aba salvou com sucesso. Se esta aba estava na mesma
		// versão (from), avança para a nova (to) — senão mantém a antiga e o PUT dará 409.
		versionBump: { type: Object, default: null },
	},
	data() {
		return {
			loading: false,
			loaded: false,
			saving: false,
			form: null,
			snapshot: null,
			version: null,
			conflictMessage: null,
			loadError: false,
		};
	},
	computed: {
		isDirty() {
			if (!this.loaded || !this.form) return false;
			const pendingFiles = typeof this.hasPendingFiles === "function" && this.hasPendingFiles();
			return pendingFiles || JSON.stringify(this.form) !== this.snapshot;
		},
	},
	watch: {
		isDirty(value) {
			this.$emit("dirty-change", value);
		},
		versionBump(bump) {
			if (bump && this.version && bump.from === this.version) this.version = bump.to;
		},
	},
	mounted() {
		this.load();
	},
	methods: {
		load() {
			this.loading = true;
			this.loadError = false;
			this.conflictMessage = null;
			return this.fetchSection()
				.then((dto) => {
					this.version = dto.version;
					this.form = this.toForm(dto);
					this.snapshot = JSON.stringify(this.form);
					if (typeof this.afterLoad === "function") this.afterLoad(dto);
					this.loaded = true;
					// Alguns inputs (máscara de dinheiro, datas) normalizam o valor ao montar;
					// tira o snapshot de novo depois da renderização para não acusar alteração falsa.
					this.$nextTick(() => {
						this.snapshot = JSON.stringify(this.form);
					});
					this.$emit("loaded", { version: dto.version });
				})
				.catch(() => {
					this.loadError = true;
				})
				.finally(() => {
					this.loading = false;
				});
		},
		save() {
			if (this.saving || !this.loaded) return Promise.resolve();
			if (typeof this.validateForm === "function" && !this.validateForm()) return Promise.resolve();

			this.saving = true;
			this.conflictMessage = null;
			const previousVersion = this.version;
			const body = Object.assign({}, this.buildPayload(), {
				campaignId: Number(this.campaignId),
				version: this.version,
			});

			return this.saveSection(body)
				.then((result) => {
					this.version = result.version;
					this.snapshot = JSON.stringify(this.form);
					if (typeof this.afterSave === "function") this.afterSave(result);
					this.$emit("saved", { from: previousVersion, to: result.version, updatedAt: result.updatedAt });
					this.$store.commit("SET_SNACKBAR_SUCCESS_MESSAGE", "Alterações salvas com sucesso!");
				})
				.catch((error) => {
					if (error && error.conflict) this.conflictMessage = error.errorMessage;
				})
				.finally(() => {
					this.saving = false;
				});
		},
		discard() {
			this.load();
		},
	},
};
